/** Pure labels of a row action (no React). A disabled action stays visible and says why. */

interface ActionLabels {
  label: string;
  disabledReason?: string;
}

/** Inline text buttons are named by their text; icon-only and disabled ones need an explicit accessible name. */
export function actionAriaLabel(a: ActionLabels, subject: string, iconOnly: boolean): string | undefined {
  const blocked = Boolean(a.disabledReason);
  if (!iconOnly && !blocked) return undefined;
  return `${a.label} ${subject}${blocked ? ` (${a.disabledReason})` : ''}`;
}

/** The tooltip of an icon-only or disabled action: the label, plus the reason when it is disabled. */
export function actionTooltip(a: ActionLabels): string {
  return a.disabledReason ? `${a.label}: ${a.disabledReason}` : a.label;
}
